import React, { useState, useEffect } from 'react';
import customerLedgerService from '../../../services/customerLedgerService';
import api from '../../../services/api';

const CustomerDetailsModal = ({ customer, onClose, onPaymentAdded }) => {
  const [transactions, setTransactions] = useState([]);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customerData, setCustomerData] = useState(customer);
  const [activeTab, setActiveTab] = useState('thismonth');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showEditSaleModal, setShowEditSaleModal] = useState(false);
const [editingSale, setEditingSale] = useState(null);
const [editSaleForm, setEditSaleForm] = useState({ quantity: '', price_per_liter: '' });
  const [paymentForm, setPaymentForm] = useState({
    amount: '',
    payment_method: 'Cash',
    payment_date: new Date().toISOString().split('T')[0],
    notes: '',
  });

  useEffect(() => {
    fetchCustomerData();
  }, [customer.id]);

  const fetchCustomerData = async () => {
    try {
      setLoading(true);
      const [ledgerRes, paymentsRes, customerRes] = await Promise.all([
        customerLedgerService.getLedger(customer.id),
        customerLedgerService.getPayments(customer.id),
        api.get(`/api/customers/${customer.id}`),
      ]);
      setTransactions(ledgerRes.data || []);
      setPayments(paymentsRes.data || []);
      setCustomerData(customerRes.data.data);
    } catch (error) {
      console.error('Error fetching customer data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddPayment = async (e) => {
    e.preventDefault();
    try {
      await customerLedgerService.addPayment(customer.id, paymentForm);
      alert('✅ Payment recorded successfully!');
      setShowPaymentModal(false);
      if (onPaymentAdded) onPaymentAdded();
      setPaymentForm({
        amount: '',
        payment_method: 'Cash',
        payment_date: new Date().toISOString().split('T')[0],
        notes: '',
      });
      fetchCustomerData();
    } catch (error) {
      alert('❌ ' + (error.response?.data?.message || 'Failed to record payment'));
    }
  };
const handleDeleteSale = async (txn) => {
  if (!window.confirm(`Delete this sale of Rs ${Math.round(parseFloat(txn.total_amount))} on ${formatDate(txn.date)}?`)) return;
  try {
    await api.delete(`/api/finance/milk-sales/${txn.id}`);
    alert('✅ Sale deleted successfully!');
    fetchCustomerData();
  } catch (error) {
    alert('❌ ' + (error.response?.data?.message || 'Failed to delete sale'));
  }
};

  const handleEditSale = async (e) => {
  e.preventDefault();
  try {
    const quantity = parseFloat(editSaleForm.quantity);
    const price = parseFloat(editSaleForm.price_per_liter);
    const total_amount = quantity * price;
    await api.put(`/api/finance/milk-sales/${editingSale.id}`, {
      quantity,
      price_per_liter: price,
      total_amount,
      amount_paid: editingSale.payment_status === 'Paid' ? total_amount : parseFloat(editingSale.amount_paid),
      amount_remaining: editingSale.payment_status === 'Paid' ? 0 : total_amount - parseFloat(editingSale.amount_paid),
    });
    alert('✅ Sale updated successfully!');
    setShowEditSaleModal(false);
    setEditingSale(null);
    fetchCustomerData();
  } catch (error) {
    alert('❌ ' + (error.response?.data?.message || 'Failed to update sale'));
  }
};

  const totalSales = transactions.reduce((sum, t) => sum + parseFloat(t.total_amount || 0), 0);
  const totalPayments = payments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

  const thisMonth = new Date().getMonth();
  const thisYear = new Date().getFullYear();
  const thisMonthTransactions = transactions.filter(t => {
    const d = new Date(t.date);
    return d.getMonth() === thisMonth && d.getFullYear() === thisYear;
  });
  const thisMonthTotal = thisMonthTransactions.reduce((sum, t) => sum + parseFloat(t.total_amount || 0), 0);

  const outstanding = parseFloat(customerData.outstanding_balance || 0);
  const creditLimit = parseFloat(customerData.credit_limit || 0);

  if (loading) {
    return (
      <div style={styles.modalOverlay} onClick={onClose}>
        <div style={styles.largeModal} onClick={(e) => e.stopPropagation()}>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <h3>Loading customer details...</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.largeModal} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div style={styles.modalHeader}>
          <div>
            <h2 style={styles.modalTitle}>👤 Customer Details</h2>
            <p style={{ color: '#7f8c8d', fontSize: '14px', margin: 0 }}>
              Full ledger and payment history
            </p>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            {outstanding > 0 && (
              <button onClick={() => setShowPaymentModal(true)} style={styles.paymentButton}>
                💰 Add Payment
              </button>
            )}
            <button onClick={onClose} style={styles.closeButton}>✕</button>
          </div>
        </div>

        {/* Customer Info Card */}
        <div style={styles.customerCard}>
          <div style={styles.customerInfo}>
            <div style={styles.customerAvatar}>
              {customerData.name.charAt(0).toUpperCase()}
            </div>
            <div>
              <h3 style={{ margin: '0 0 4px 0', fontSize: '20px', fontWeight: '700' }}>
                {customerData.name}
              </h3>
              <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '4px' }}>
                📞 {customerData.phone}
              </div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>
                📍 {customerData.address || 'No address'}
              </div>
            </div>
          </div>
          <div style={styles.customerMeta}>
            <div style={styles.metaItem}>
              <span style={styles.metaLabel}>Payment Terms</span>
              <span style={{
                background: customerData.payment_terms === 'Cash' ? '#d4edda' : '#fff3cd',
                color: customerData.payment_terms === 'Cash' ? '#155724' : '#856404',
                padding: '4px 12px', borderRadius: '12px', fontSize: '13px', fontWeight: '600'
              }}>
                {customerData.payment_terms}
              </span>
            </div>
            {customerData.payment_terms === 'Credit' && creditLimit > 0 && (
              <div style={styles.metaItem}>
                <span style={styles.metaLabel}>Credit Limit</span>
                <span style={{ fontWeight: '700', fontSize: '16px' }}>
                  Rs {creditLimit.toLocaleString()}
                </span>
              </div>
            )}
            <div style={styles.metaItem}>
              <span style={styles.metaLabel}>Outstanding</span>
              <div>
                <span style={{ fontWeight: '700', fontSize: '20px', color: outstanding > 0 ? '#ff6b6b' : '#51cf66' }}>
                  Rs {outstanding.toLocaleString()}
                </span>
                {creditLimit > 0 && outstanding > creditLimit && (
                  <div style={{ fontSize: '11px', background: '#ff6b6b', color: 'white', padding: '2px 8px', borderRadius: '10px', marginTop: '4px', fontWeight: '600' }}>
                    ⚠️ Credit Limit Exceeded!
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div style={styles.statsGrid}>
          <div style={styles.statCard}>
            <div style={styles.statValue}>Rs {Math.round(totalSales).toLocaleString()}</div>
            <div style={styles.statLabel}>Total Sales</div>
          </div>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#27ae60' }}>
              Rs {Math.round(totalPayments).toLocaleString()}
            </div>
            <div style={styles.statLabel}>Total Payments</div>
          </div>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#3498db' }}>
              Rs {Math.round(thisMonthTotal).toLocaleString()}
            </div>
            <div style={styles.statLabel}>This Month</div>
          </div>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#e74c3c' }}>
              Rs {Math.round(outstanding).toLocaleString()}
            </div>
            <div style={styles.statLabel}>Current Due</div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: '4px', padding: '0 30px', borderBottom: '2px solid #f0f0f0', marginBottom: '0' }}>
          {['thismonth', 'payments', 'ledger'].map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: '12px 20px',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '700',
                color: activeTab === tab ? '#3498db' : '#7f8c8d',
                borderBottom: activeTab === tab ? '3px solid #3498db' : '3px solid transparent',
                marginBottom: '-2px',
              }}
            >
              {tab === 'ledger' && `📝 All Transactions (${transactions.length})`}
              {tab === 'payments' && `💰 Payments (${payments.length})`}
              {tab === 'thismonth' && `📅 This Month (${thisMonthTransactions.length})`}
            </button>
          ))}
        </div>

        {/* Ledger Tab */}
        {activeTab === 'ledger' && (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.headerRow}>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Session</th>
                  <th style={styles.th}>Milk Type</th>
                  <th style={styles.th}>Qty (L)</th>
                  <th style={styles.th}>Price/L</th>
                  <th style={styles.th}>Total</th>
                  <th style={styles.th}>Paid</th>
                  <th style={styles.th}>Remaining</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {transactions.length === 0 ? (
                  <tr><td colSpan="9" style={styles.noData}>No transactions found</td></tr>
                ) : (
                  transactions.map(txn => (
                    <tr key={txn.id} style={styles.row}>
                      <td style={styles.td}>{formatDate(txn.date)}</td>
                      <td style={styles.td}>{txn.session || '-'}</td>
                      <td style={styles.td}>{txn.milk_type}</td>
                      <td style={styles.td}>{parseFloat(txn.quantity)}</td>
                      <td style={styles.td}>Rs {parseFloat(txn.price_per_liter)}</td>
                      <td style={styles.td}><strong>Rs {Math.round(parseFloat(txn.total_amount)).toLocaleString()}</strong></td>
                      <td style={styles.td}>Rs {Math.round(parseFloat(txn.amount_paid)).toLocaleString()}</td>
                      <td style={styles.td}>
                        {parseFloat(txn.amount_remaining) > 0
                          ? <strong style={{ color: '#e74c3c' }}>Rs {Math.round(parseFloat(txn.amount_remaining)).toLocaleString()}</strong>
                          : <span style={{ color: '#27ae60' }}>Rs 0</span>}
                      </td>
                      
                      <td style={styles.td}>
                        <span style={getPaymentStatusStyle(outstanding === 0 ? 'Paid' : txn.payment_status)}>
                          {outstanding === 0 ? 'Paid' : txn.payment_status}
                        </span>
                      </td>

                      <td style={styles.td}>
  <div style={{ display: 'flex', gap: '6px' }}>
    <button
      onClick={() => {
        setEditingSale(txn);
        setEditSaleForm({ quantity: txn.quantity, price_per_liter: txn.price_per_liter });
        setShowEditSaleModal(true);
      }}
      style={{ padding: '4px 10px', background: '#3498db', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
    >
      ✏️ Edit
    </button>
    <button
      onClick={() => handleDeleteSale(txn)}
      style={{ padding: '4px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
    >
      🗑️ Del
    </button>
  </div>
</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Payments Tab */}
        {activeTab === 'payments' && (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.headerRow}>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Method</th>
                  <th style={styles.th}>Notes</th>
                </tr>
              </thead>
              <tbody>
                {payments.length === 0 ? (
                  <tr><td colSpan="4" style={styles.noData}>No payments recorded yet</td></tr>
                ) : (
                  payments.map(p => (
                    <tr key={p.id} style={styles.row}>
                      <td style={styles.td}>{formatDate(p.payment_date)}</td>
                      <td style={styles.td}>
                        <strong style={{ color: '#27ae60' }}>Rs {Math.round(parseFloat(p.amount)).toLocaleString()}</strong>
                      </td>
                      <td style={styles.td}>
                        <span style={styles.paymentMethodBadge}>{p.payment_method}</span>
                      </td>
                      <td style={styles.td}>{p.notes || '-'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* This Month Tab */}
        {activeTab === 'thismonth' && (
          <div style={styles.tableContainer}>
            <div style={{ padding: '16px', background: '#e8f5e9', borderRadius: '8px', margin: '16px 0', display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
              <span>🥛 Total Liters: <strong>{thisMonthTransactions.reduce((s, t) => s + parseFloat(t.quantity || 0), 0)}L</strong></span>
              <span>💰 Total Amount: <strong>Rs {Math.round(thisMonthTotal).toLocaleString()}</strong></span>
              <span>📦 Entries: <strong>{thisMonthTransactions.length}</strong></span>
            </div>
            <table style={styles.table}>
              <thead>
                <tr style={styles.headerRow}>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Session</th>
                  <th style={styles.th}>Milk Type</th>
                  <th style={styles.th}>Qty (L)</th>
                  <th style={styles.th}>Total</th>
                  <th style={styles.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {thisMonthTransactions.length === 0 ? (
                  <tr><td colSpan="6" style={styles.noData}>No transactions this month</td></tr>
                ) : (
                  thisMonthTransactions.map(txn => (
                    <tr key={txn.id} style={styles.row}>
                      <td style={styles.td}>{formatDate(txn.date)}</td>
                      <td style={styles.td}>{txn.session || '-'}</td>
                      <td style={styles.td}>{txn.milk_type}</td>
                      <td style={styles.td}>{parseFloat(txn.quantity)}</td>
                      <td style={styles.td}><strong>Rs {Math.round(parseFloat(txn.total_amount)).toLocaleString()}</strong></td>
                       
                      <td style={styles.td}>
                        <span style={getPaymentStatusStyle(outstanding === 0 ? 'Paid' : txn.payment_status)}>
                          {outstanding === 0 ? 'Paid' : txn.payment_status}
                        </span>
                      </td>

                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={styles.modalFooter}>
          <button onClick={onClose} style={styles.closeFooterButton}>Close</button>
        </div>
      </div>

      {/* Add Payment Modal */}
      {showPaymentModal && (
        <div style={{ ...styles.modalOverlay, zIndex: 1100 }} onClick={() => setShowPaymentModal(false)}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '450px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '20px', color: '#2c3e50' }}>
              💰 Add Payment — {customerData.name}
            </h3>
            <div style={{ background: '#fff3cd', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' }}>
              Outstanding: <strong style={{ color: '#e74c3c' }}>Rs {outstanding.toLocaleString()}</strong>
            </div>
            <form onSubmit={handleAddPayment}>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>Amount (PKR) <span style={{ color: '#e74c3c' }}>*</span></label>
                <input
                  type="number"
                  step="1"
                  value={paymentForm.amount}
                  onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })}
                  style={formStyles.input}
                  placeholder="Enter amount received"
                  required
                />
              </div>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>Payment Method <span style={{ color: '#e74c3c' }}>*</span></label>
                <select
                  value={paymentForm.payment_method}
                  onChange={(e) => setPaymentForm({ ...paymentForm, payment_method: e.target.value })}
                  style={formStyles.input}
                  required
                >
                  <option value="Cash">Cash</option>
                  <option value="Bank Transfer">Bank Transfer</option>
                  <option value="JazzCash">JazzCash</option>
                  <option value="EasyPaisa">EasyPaisa</option>
                  <option value="Cheque">Cheque</option>
                </select>
              </div>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>Payment Date <span style={{ color: '#e74c3c' }}>*</span></label>
                <input
                  type="date"
                  value={paymentForm.payment_date}
                  onChange={(e) => setPaymentForm({ ...paymentForm, payment_date: e.target.value })}
                  style={formStyles.input}
                  required
                />
              </div>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>Notes</label>
                <textarea
                  value={paymentForm.notes}
                  onChange={(e) => setPaymentForm({ ...paymentForm, notes: e.target.value })}
                  style={{ ...formStyles.input, minHeight: '60px', resize: 'vertical' }}
                  placeholder="Optional notes..."
                  rows="2"
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                <button type="button" onClick={() => setShowPaymentModal(false)} style={formStyles.cancelButton}>Cancel</button>
                <button type="submit" style={formStyles.submitButton}>💾 Save Payment</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Edit Sale Modal */}
{showEditSaleModal && editingSale && (
  <div style={{ ...styles.modalOverlay, zIndex: 1100 }} onClick={() => setShowEditSaleModal(false)}>
    <div style={{ background: 'white', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '400px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }} onClick={(e) => e.stopPropagation()}>
      <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '20px', color: '#2c3e50' }}>
        ✏️ Edit Sale Entry
      </h3>
      <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '13px', color: '#555' }}>
        <div><strong>Date:</strong> {formatDate(editingSale.date)}</div>
        <div><strong>Session:</strong> {editingSale.session}</div>
        <div><strong>Milk Type:</strong> {editingSale.milk_type}</div>
      </div>
      <form onSubmit={handleEditSale}>
        <div style={formStyles.formGroup}>
          <label style={formStyles.label}>Quantity (L) *</label>
          <input
            type="number"
            step="0.5"
            min="0"
            value={editSaleForm.quantity}
            onChange={(e) => setEditSaleForm({ ...editSaleForm, quantity: e.target.value })}
            style={formStyles.input}
            required
          />
        </div>
        <div style={formStyles.formGroup}>
          <label style={formStyles.label}>Price per Liter (Rs) *</label>
          <input
            type="number"
            step="1"
            min="0"
            value={editSaleForm.price_per_liter}
            onChange={(e) => setEditSaleForm({ ...editSaleForm, price_per_liter: e.target.value })}
            style={formStyles.input}
            required
          />
        </div>
        {editSaleForm.quantity && editSaleForm.price_per_liter && (
          <div style={{ background: '#e8f5e9', borderRadius: '8px', padding: '10px 14px', marginBottom: '12px', textAlign: 'center' }}>
            <strong style={{ color: '#27ae60' }}>
              New Total: Rs {Math.round(parseFloat(editSaleForm.quantity) * parseFloat(editSaleForm.price_per_liter)).toLocaleString()}
            </strong>
          </div>
        )}
        <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
          <button type="button" onClick={() => setShowEditSaleModal(false)} style={formStyles.cancelButton}>Cancel</button>
          <button type="submit" style={formStyles.submitButton}>💾 Update Sale</button>
        </div>
      </form>
    </div>
  </div>
)}
    </div>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const getPaymentStatusStyle = (status) => {
  const s = {
    'Paid': { background: '#d4edda', color: '#155724', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' },
    'Partial': { background: '#fff3cd', color: '#856404', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' },
    'Unpaid': { background: '#f8d7da', color: '#721c24', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' },
  };
  return s[status] || s['Unpaid'];
};

const formStyles = {
  formGroup: { display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#2c3e50' },
  input: { width: '100%', padding: '10px 12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' },
  cancelButton: { flex: 1, padding: '12px', background: '#95a5a6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  submitButton: { flex: 1, padding: '12px', background: '#27ae60', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
};

const styles = {
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' },
  largeModal: { background: 'white', borderRadius: '12px', width: '95%', maxWidth: '1200px', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' },
  modalHeader: { padding: '24px 30px', borderBottom: '2px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 10 },
  modalTitle: { fontSize: '24px', fontWeight: '700', color: '#2c3e50', margin: '0 0 4px 0' },
  closeButton: { padding: '8px 16px', background: '#f0f0f0', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '20px', fontWeight: '700', color: '#666' },
  paymentButton: { padding: '10px 20px', background: '#27ae60', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  customerCard: { background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '30px', margin: '24px 30px', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' },
  customerInfo: { display: 'flex', alignItems: 'center', gap: '20px' },
  customerAvatar: { width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px', fontWeight: '700', color: 'white' },
  customerMeta: { display: 'flex', gap: '30px', flexWrap: 'wrap' },
  metaItem: { display: 'flex', flexDirection: 'column', gap: '4px' },
  metaLabel: { fontSize: '12px', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', padding: '0 30px', marginBottom: '24px' },
  statCard: { background: '#f8f9fa', padding: '20px', borderRadius: '12px', textAlign: 'center' },
  statValue: { fontSize: '28px', fontWeight: '700', color: '#3498db', marginBottom: '8px' },
  statLabel: { fontSize: '12px', color: '#7f8c8d', textTransform: 'uppercase', letterSpacing: '0.5px' },
  tableContainer: { padding: '0 30px 20px' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '16px' },
  headerRow: { background: '#f8f9fa' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '700', color: '#2c3e50', borderBottom: '2px solid #e0e0e0' },
  row: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#2c3e50' },
  noData: { padding: '40px 20px', textAlign: 'center', color: '#95a5a6', fontSize: '14px' },
  paymentMethodBadge: { background: '#e3f2fd', color: '#1565c0', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' },
  modalFooter: { padding: '20px 30px', borderTop: '2px solid #f0f0f0', display: 'flex', justifyContent: 'flex-end', position: 'sticky', bottom: 0, background: 'white' },
  closeFooterButton: { padding: '12px 24px', background: '#95a5a6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
};

export default CustomerDetailsModal;